import { useState, useEffect } from 'react';

export default function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showIndicator, setShowIndicator] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowIndicator(true);
      // Hide the "back online" indicator after 3 seconds
      setTimeout(() => setShowIndicator(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowIndicator(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Show indicator initially if offline
    if (!navigator.onLine) {
      setShowIndicator(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showIndicator) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-down">
      <div
        className={`relative px-6 py-3 border-4 border-black font-black text-sm ${
          isOnline
            ? 'bg-emerald-500 text-white'
            : 'bg-red-500 text-white animate-pulse'
        }`}
      >
        <div
          className={`absolute -bottom-1 -right-1 w-full h-full -z-10 ${
            isOnline ? 'bg-emerald-700' : 'bg-red-700'
          }`}
        ></div>
        <div className="flex items-center space-x-2">
          <div className="text-lg">{isOnline ? '🟢' : '🔴'}</div>
          <span className="uppercase tracking-wider">
            {isOnline ? 'BACK ONLINE' : 'OFFLINE MODE'}
          </span>
        </div>
      </div>
    </div>
  );
}
